import React from 'react';
import REText from '@components/wrappedBDS/REText';

const CancelOrder = (props) => {
  return <REText>{props.message}</REText>;
};

export default CancelOrder;
